module.exports = __webpack_public_path__ + "img/icon-r-play.4bf7b9ae.svg";